import { Box, CircularProgress, Grid, keyframes, Skeleton, Typography } from "@mui/material";
import { useEffect, useId, useState } from "react";
import Eventgen from "./Eventgen";
import event1img from '../assets/images/events/Web 2.jpg';
import event2img from '../assets/images/events/blddon2.jpg';
import event3img from '../assets/images/events/se.jpg';
import blddon from '../assets/images/events/blddon.jpeg';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

function EventBar() {
    const [index, setIndex] = useState(0);
    const [loading, setLoading] = useState(true);
    /** SVG filter id (no colons) for `filter: url(#…)` compatibility */
    const horizBlurFilterId = `event-horiz-blur-${useId().replace(/:/g, "")}`;

    const events = [
        {
            title: 'Blood Donation Campaign 2026',
            description: `Every drop counts… and your one act of kindness can save up to three lives. Join us on 24th May for our Blood Donation Campaign and be a hero in someone’s story. Whether it’s your first time or you’re a regular donor, your contribution matters more than you think. Let’s come together, give hope, and make a difference. 
            Date: 24th May , Location: Narahenpita Blood Bank`,
            image: blddon,
            href: 'https://whatsapp.com/channel/0029VbAHJCkFnSz9KOk1Y32U',
            time: '2026-05-24T09:00:00Z'
        },
        {
            title: 'Blood Donation 2025',
            description: `The Alumni Association of Uva Wellassa University is organizing a blood donation drive on May 18, 2025, at the National Blood Bank in Narahenpita from 9:00 AM to 3:00 PM. Your generous act not only saves lives but also demonstrates the strength and spirit of our alumni network in supporting vital causes. Join us for this important event and contribute to a healthier, stronger community.`,
            image: event2img,
            href: 'https://www.facebook.com/share/1HUXbiAe9w/',
            time: '2025-05-18T08:00:00Z'
        },
        {
            title: 'UWU Legends League 2025',
            description: `The Alumni Association of Uva Wellassa University is thrilled to announce the 3rd UWU Legends League, taking place on March 1st, 2025, at 9:00 AM at Shalika Ground, Narahenpita. This cherished tradition unites alumni from 14 graduating batches for a thrilling cricket tournament, fostering camaraderie and sportsmanship.`,
            image: event1img,
            href: 'https://www.facebook.com/uwulegendsleague',
            time: '2025-03-01T09:00:00Z'
        },
        {
            title: 'Mr. Charith Wimaladharma Scholarship Program for UWU Undergraduates',
            description: `Alumni Association of Uva Wellassa University is embarking on a scholarship scheme “CHARITHA WIMALADHARMA MEMORIAL SCHOLARSHIP” to UWU Undergraduates.`,
            image: event3img,
            href: 'https://forms.gle/1kx89UeA6DXJBkL89',
            time: '2024-03-30T00:00:00Z'
        }
    ];

    const handleImageLoad = () => {
        setLoading(false);
    };

    const backbtnH = () => {
        setLoading(true);
        setIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : events.length - 1));
    };

    const nexbtnH = () => {
        setLoading(true);
        setIndex((prevIndex) => (prevIndex < events.length - 1 ? prevIndex + 1 : 0));
    };
    useEffect(() => {
        const img = new Image();
        console.log(events[index].image);
        img.src = events[index].image;
        img.onload = () => setLoading(false);
        img.onerror = (err) => console.error("Failed to load image", err);
    }, [index]);

    return (
        <>
            <svg width={0} height={0} style={{ position: "absolute", visibility: "hidden" }} aria-hidden>
                <defs>
                    <filter id={horizBlurFilterId} x="-20%" y="-20%" width="140%" height="140%">
                        <feGaussianBlur in="SourceGraphic" stdDeviation="22 0" />
                    </filter>
                </defs>
            </svg>
            <Typography id={"Event"}
                align="right"
                variant="h3"
                sx={{
                    width: { xs: "98%", sm: "98%", md: "98%", lg: "90%", xl: "90%" },
                    color: '#091D3D',
                    fontWeight: '600',
                    marginBottom: '50px',
                    marginTop: '50px'
                }}
            >
                Our Events
            </Typography>
            <Box
                sx={{
                    width: { xs: "98%", sm: "98%", md: "98%", lg: "90%", xl: "90%" },
                    height: 'auto',
                    minHeight: { lg: 360 },
                    display: 'flex',
                    justifyContent: 'right',
                    position: 'relative',
                    marginBottom: '150px',
                }}
            >
                <Box
                    sx={{
                        width: '65%',
                        minHeight: { lg: 280 },
                        height: { xs: 0, sm: 0, md: 0, lg: 'min(72%, 520px)', xl: 'min(72%, 620px)' },
                        display: { xs: "none", sm: "none", md: "none", lg: "block", xl: "block" },
                        position: 'absolute',
                        right: 0,
                        top: '12%',
                        paddingBottom: '50px',
                        background: '#EFF1F4'
                    }}
                />
                <Box
                    sx={{
                        position: 'relative',
                        left: '0',
                        zIndex: 3,
                        width: '98%',
                        padding: '3% 0% 5% 0%'
                    }}
                >
                    <Grid container spacing={5} alignItems="center">
                        <Grid
                            item
                            md={12}
                            lg={6}
                            sm={12}
                            xs={12}
                            sx={{ display: 'flex', justifyContent: 'center' }}
                        >
                            <Box
                                sx={{
                                    position: 'relative',
                                    /** Centered inside the column; image keeps a fixed 16:9 frame so its size doesn't follow the (often taller) details column */
                                    width: '100%',
                                    maxWidth: { xs: '100%', lg: 'min(100%, 1080px)' },
                                    mx: 'auto',
                                    aspectRatio: '16 / 9',
                                    overflow: 'hidden',
                                    bgcolor: '#EFF1F4',
                                    isolation: 'isolate'
                                }}
                            >
                                <Box
                                    key={index}
                                    sx={{
                                        position: 'absolute',
                                        inset: 0,
                                        animation: `${fadeIn} 0.3s ease-in-out`
                                    }}
                                >
                                    {loading ? (
                                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                            <Skeleton variant="rectangular" width="100%" height="100%" sx={{ bgcolor: 'rgba(9, 29, 61, 0.06)' }} />
                                        </Box>
                                    ) : (
                                        <>
                                            {/* Fills 16:9 frame: cover + horizontal blur for side bands when aspect differs */}
                                            <Box
                                                aria-hidden
                                                sx={{
                                                    position: 'absolute',
                                                    // Slight inset bleed so blur does not clip harshly at edges
                                                    inset: -12,
                                                    backgroundImage: `url(${events[index].image})`,
                                                    backgroundRepeat: 'no-repeat',
                                                    backgroundSize: 'cover',
                                                    backgroundPosition: 'center',
                                                    filter: `url(#${horizBlurFilterId})`,
                                                    transform: 'scale(1.08)',
                                                    opacity: 0.55
                                                }}
                                            />
                                            <Box
                                                aria-hidden
                                                sx={{
                                                    position: 'absolute',
                                                    inset: 0,
                                                    background: 'linear-gradient(180deg, rgba(239, 241, 244, 0.35) 0%, rgba(9, 29, 61, 0.08) 100%)',
                                                    pointerEvents: 'none'
                                                }}
                                            />
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    inset: 0,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    zIndex: 1
                                                }}
                                            >
                                                <img
                                                    src={events[index].image}
                                                    alt={events[index].title}
                                                    onLoad={handleImageLoad}
                                                    sizes="(max-width: 900px) 96vw, (max-width: 1200px) 45vw, min(50vw, 1080px)"
                                                    decoding="async"
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        maxWidth: '100%',
                                                        maxHeight: '100%',
                                                        objectFit: 'contain',
                                                        objectPosition: 'center',
                                                        imageRendering: 'auto',
                                                        position: 'relative',
                                                        zIndex: 1
                                                    }}
                                                />
                                            </Box>
                                        </>
                                    )}
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item md={12} lg={6} sm={12}>
                            <Eventgen
                                nextH={nexbtnH}
                                backH={backbtnH}
                                time={events[index].time}
                                title={events[index].title}
                                href={events[index].href}
                                description={events[index].description}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </>
    );
}

export default EventBar;
